'use strict';

import config from '../config/config';

var $ = require('jquery');

var util = {
    contentSplitter: '%$%$%$SPLITME%$%$%$',

    /**
     * @function
     * @description disable the create account button with the reference of the T&C checkbox status
     * @param {Boolean} isEnabled true for T&C enabled
     * @param {jQuery Object} The target container for this
     */
    toggleFormSubmitEnabled: function (termsAndConditionsBtns) {
        let allChecked = true;

        // Iterate through each button and check if all are checked
        termsAndConditionsBtns.each(function () {
            if (!$(this).is(':checked')) {
                allChecked = false;
                return false; // Exit the loop early if any button is not checked
            }
        });

        // Find the submit button
        let submitRegisterBtn = termsAndConditionsBtns.closest('form').find(':submit');

        // Enable or disable the submit button based on allChecked
        if (allChecked) {
            $(submitRegisterBtn).removeAttr('disabled');
        } else {
            $(submitRegisterBtn).attr('disabled', 'disabled');
        }
    },
    /**
     * @function
     * @description adds generic toggle functionality to all .toggle in a container
     * @param {jQuery Object} $target The target container for this, defaults to document
     */
    addToggleEvents: function ($target) {
        if ($target === null || $target === undefined) {
            $target = $(document); // eslint-disable-line no-param-reassign
        }
        $target
            .find('.toggle')
            .on('click', function () {
                var $toggleTrigger = $(this);
                var $toggleContent = $toggleTrigger.next('.toggle-content');
                $toggleTrigger.add($toggleContent).toggleClass('expanded').toggleClass('collapsed');
                $toggleContent.slideToggle();
            })
            .each(function () {
                var $this = $(this);
                var $toggleContent = $this.next('.toggle-content');
                if (!$this.hasClass('expanded') && !$this.hasClass('collapsed')) {
                    if ($this.parents('.not-for-desktop').length > 0) {
                        $this.add($toggleContent).addClass('collapsed');
                    } else {
                        $this.add($toggleContent).addClass('expanded');
                    }
                }
            });
    },
    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {String} url the url to which the parameter will be added
     * @param {String} name the name of the parameter
     * @param {String} value the value of the parameter
     */
    appendParamToURL: function (url, name, value) {
        var separator;
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        separator = url.indexOf('?') !== -1 ? '&' : '?';
        return url + separator + name + '=' + encodeURIComponent(value);
    },

    /**
     * @function
     * @description remove the parameter and its value from the given url and returns the changed url
     * @param {String} url the url from which the parameter will be removed
     * @param {String} name the name of parameter that will be removed from url
     */
    removeParamFromURL: function (url, name) {
        var hash;
        var params;
        var domain;
        var paramUrl;
        var newParams;
        var i;
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        domain = url.split('?')[0];
        paramUrl = url.split('?')[1];
        newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }
        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function (url, params) {
        var theUrl = url;
        var name;

        for (name in params) {
            if (params[name]) {
                theUrl = this.appendParamToURL(theUrl, name, params[name]);
            }
        }

        return theUrl;
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {String} url the url to extra query string from
     */
    getQueryString: function (url) {
        var qs;
        var a;
        if (typeof url !== 'string') {
            return undefined;
        }
        a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },

    /**
     * Create a query string from an key-value object.
     * @param params
     * @return {string}
     */
    objectToQueryString: function (params) {
        var arr = [];
        for (var p in params) {
            arr.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]));
        }

        return arr.join('&');
    },
    /**
     * @function
     * @description
     * @param {String}
     * @param {String}
     */
    elementInViewport: function (el, offsetToTop) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent; // eslint-disable-line no-param-reassign
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        if (offsetToTop !== undefined) {
            top -= offsetToTop;
        }

        if (window.pageXOffset !== null) {
            return (
                top < window.pageYOffset + window.innerHeight &&
                left < window.pageXOffset + window.innerWidth &&
                top + height > window.pageYOffset &&
                left + width > window.pageXOffset
            );
        }

        if (document.compatMode === 'CSS1Compat') {
            return (
                top < window.document.documentElement.scrollTop + window.document.documentElement.clientHeight &&
                left < window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth &&
                top + height > window.document.documentElement.scrollTop &&
                left + width > window.document.documentElement.scrollLeft
            );
        }
    },

    /**
     * @function
     * @description Appends the parameter 'format=ajax' to a given path
     * @param {String} path the relative path
     */
    ajaxUrl: function (path) {
        return this.appendParamToURL(path, 'format', 'ajax');
    },

    /**
     * @function
     * @description
     * @param {String} url
     */
    toAbsoluteUrl: function (url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url; // eslint-disable-line no-param-reassign
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function (urls) {
        var i;
        var len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {String} url The url from which css file will be dynamically loaded.
     */
    loadCssFile: function (url) {
        return $('<link/>')
            .appendTo($('head'))
            .attr({
                type: 'text/css',
                rel: 'stylesheet'
            })
            .attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function () {
        var i = this.loadedCssFiles.length;
        while (i-- < 0) {
            $(this.loadedCssFiles[i]).remove();
        }
        this.loadedCssFiles = [];
    },
    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function (qs) {
        var params = {};
        var unescapedQS;
        if (!qs || qs.length === 0) {
            return {};
        }
        unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
            params[$1] = $3;
        });
        return params;
    },

    fillAddressFields: function (address, $form) {
        var field;
        for (field in address) {
            // eslint-disable-line no-restricted-syntax
            if (address.hasOwnProperty(field)) {
                // eslint-disable-line no-prototype-builtins
                if (field === 'ID' || field === 'UUID' || field === 'key') {
                    continue; // eslint-disable-line no-continue
                }
                // if the key in address object ends with 'Code', remove that suffix
                // keys that ends with 'Code' are postalCode, stateCode and countryCode
                $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
                // update the state fields
                if (field === 'countryCode') {
                    $form.find('[name$="country"]').trigger('change');
                    // retrigger state selection after country has changed
                    // this results in duplication of the state code, but is a necessary evil
                    // for now because sometimes countryCode comes after stateCode
                    $form.find('[name$="state"]').val(address.stateCode);
                }
            }
        }
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area
     */
    limitCharacters: function () {
        $('form')
            .find('textarea[data-character-limit]')
            .each(function () {
                var characterLimit = $(this).data('character-limit');
                var charCountHtml = String.format(
                    Resources.CHAR_LIMIT_MSG,
                    '<span class="char-remain-count">' + characterLimit + '</span>',
                    '<span class="char-allowed-count">' + characterLimit + '</span>'
                );
                var charCountContainer = $(this).next('div.char-count');
                if (charCountContainer.length === 0) {
                    charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
                }
                charCountContainer.html(charCountHtml);
                // trigger the keydown event so that any existing character data is calculated
                $(this).change();
            });
    },
    /**
     * @function
     * @description Binds the onclick-event to a delete button on a given container,
     * which opens a confirmation box with a given message
     * @param {String} container The name of element to which the function will be bind
     * @param {String} message The message the will be shown upon a click
     */
    setDeleteConfirmation: function (container, message) {
        $(container).on('click', '.delete', function () {
            return window.confirm(message); // eslint-disable-line no-alert
        });
    },
    /**
     * @function
     * @description Scrolls a browser window to a given x point
     * @param {String} The x coordinate
     */
    scrollBrowser: function (xLocation, respectFixedHeader) {
        var headerHeight = 0;

        $('.header-wrapper, #header_1774').each(function () {
            var $this = $(this);
            headerHeight = $this.outerHeight() > headerHeight ? $this.outerHeight() : headerHeight;
        });

        if (respectFixedHeader) {
            xLocation -= headerHeight; // eslint-disable-line no-param-reassign
        }

        requestAnimationFrame(function () {
            $('html, body').animate({scrollTop: xLocation}, 500);
        });
    },

    isMobile: function () {
        return window.matchMedia(`(max-width: ${config.BREAKPOINTS.MOBILE_MAX}px)`).matches;
    },

    isTablet: function () {
        return window.matchMedia(
            `(min-width: ${config.BREAKPOINTS.TABLET_MIN}px) and (max-width: ${config.BREAKPOINTS.TABLET_MAX}px)`
        ).matches;
    },

    isMobileOrTablet: function () {
        return $(window).width() <= 1023;
    },

    isFirefox: function () {
        return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    },

    isInternetExplorer: function () {
        if (navigator.userAgent.toLowerCase().indexOf('msie') > -1) {
            return true;
        }

        if (navigator.userAgent.toLowerCase().indexOf('trident') > -1) {
            return true;
        }

        return false;
    },

    /**
     * @function
     * @description Delets items from session storage which matchs given regex
     * @param {String} regex
     */
    deleteSessionStorageData: function (regex) {
        if (regex) {
            Object.keys(sessionStorage).forEach(function (key) {
                if (regex.test(key)) {
                    sessionStorage.removeItem(key);
                }
            });
        }
    },

    getParameterByName: function (name, url) {
        var regex;
        var results;
        if (!url) url = window.location.href; // eslint-disable-line no-param-reassign
        name = name.replace(/[[\]]/g, '\\$&'); // eslint-disable-line no-param-reassign
        regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    /**
     * @function
     * @description check if the given element is in the viewport
     * @param el
     * @return {Boolean} if the element is fully in the viewport
     */
    isElementInViewport: function (el) {
        if (el === null) {
            return false;
        }
        var rect = el.getBoundingClientRect();
        var html = document.documentElement;
        var windowHeight = window.innerHeight || html.clientHeight;

        return rect.top > 0 && rect.left > 0 && rect.bottom < windowHeight && rect.right < windowHeight;
    },
    /**
     * @function
     * @description check if the given element has reached viewport
     * @param el
     * @return {Boolean} if the element has reached viewport
     */
    isElementReachedViewport: function (el) {
        if (el.length === 0) {
            return true;
        }

        var elTop = el.offset().top;
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elTop < viewportBottom;
    },
    parseJSON: function (data, logError) {
        logError = logError || false;

        try {
            return JSON.parse(data);
        } catch (e) {
            if (logError) {
                console.error(e);
            }
        }
    },
    isClickOrSpaceOrEnter: function (event) {
        if (event.type === 'click') {
            return true;
        } else if (event.type === 'keypress') {
            var code = event.charCode || event.keyCode;
            if (code === 32 || code === 13) {
                return true;
            }
        } else {
            return false;
        }
    },

    /**
     * @function
     * @description Provide sharing link (current page) to share
     * with utm parameter
     */
    getSharingLink: function () {
        const utmParam = {
            utm_source: 'webshop',
            utm_medium: 'referral',
            utm_campaign: 'pdp_sharing'
        };
        const existingParam = this.getQueryStringParams(window.location.search);
        Object.assign(existingParam, utmParam);
        let sharingUrl = this.appendParamsToUrl(window.location.href.split('?')[0], existingParam);
        return sharingUrl;
    }
};

module.exports = util;
